import { ChangeEvent } from 'react'
import { TbChevronDown } from 'react-icons/tb'
import { CategoryCompactType } from 'routes/Integrations/helpers/types'
import { useIntegrationCategories } from 'routes/Integrations/context/IntegrationCategoriesContext'
import { IntegrationsCategoriesSelectItem } from './IntegrationsCategoriesSelectItem'
import classes from './IntegrationsCategoriesSelect.module.scss'

export const IntegrationsCategoriesSelect = ({
  filteredCategories,
  loading,
  value,
  onChange,
}: {
  filteredCategories: CategoryCompactType[]
  loading: boolean
  value?: string
  onChange: (category: string) => void
}) => {
  const categories = useIntegrationCategories()

  function handleSelectChange(e: ChangeEvent<HTMLSelectElement>) {
    onChange(e.target.value)
  }

  return (
    <div className={classes.wrapper}>
      <select
        aria-label='select integrations category'
        value={value}
        className={classes.dropdown}
        onChange={handleSelectChange}
      >
        {categories.map((item, idx) => (
          <IntegrationsCategoriesSelectItem
            key={idx}
            item={item}
            filteredCategories={filteredCategories}
            loading={loading}
          />
        ))}
      </select>
      <TbChevronDown className={classes.icon} />
    </div>
  )
}
